import React, { useEffect, useRef, useState } from 'react';
import { Modal, Form, Input, Button, Select, Tabs, Col, Row } from 'antd';
import IntlMessages from '../../components/IntlMessage';
import { useIntl } from 'react-intl';
import customersApi from '../../api/customers';
import cGroupsApi from '../../api/cgroups';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import useValidate from '../../hooks/useValidate';
import CountryData from '../../utils/countrydata';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};
const { Option } = Select;
export default function CustomersForm(props) {
  const isMount = useRef(false);
  const { onClose, currentData, open } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const [cGroups, setCGroups] = useState([]);
  const { isPhoneNumber } = useValidate();
  const place_pass = 'input password';

  let initialValues = {
    firstname:
      currentData && currentData.firstname ? currentData.firstname : '',
    lastname: currentData && currentData.lastname ? currentData.lastname : '',
    email: currentData && currentData.email ? currentData.email : null,
    accountant_email:
      currentData && currentData.accountant_email
        ? currentData.accountant_email
        : '',
    mobile: currentData && currentData.mobile ? currentData.mobile : '',
    phone_code:
      currentData && currentData.phone_code ? currentData.phone_code : '',
    cgroup_id: currentData && currentData.cgroup ? currentData.cgroup?.id : '',
    company_name:
      currentData && currentData.company_name ? currentData.company_name : '',
    company_shortname:
      currentData && currentData.company_shortname
        ? currentData.company_shortname
        : '',
    company_tax_id:
      currentData && currentData.company_tax_id
        ? currentData.company_tax_id
        : '',
    address: currentData && currentData.address ? currentData.address : '',
    office: currentData && currentData.office ? currentData.office : '',
    notes: currentData && currentData.notes ? currentData.notes : '',
    passport: currentData && currentData.passport ? currentData.passport : '',
    userId: currentData && currentData.userId ? currentData.userId : null,
    contact_info:
      currentData && currentData.contact_info
        ? Array.isArray(currentData.contact_info)
          ? currentData.contact_info
          : JSON.parse(currentData.contact_info)
        : [],
  };

  // side effects
  useEffect(() => {
    isMount.current = true;
    (async function () {
      if (isMount) {
        let items = await cGroupsApi.getAll({
          page: 1,
          limit: 9999,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
        });
        // console.log('cGroups: ', items);
        const cGroupsData = items?.data;
        if (Array.isArray(cGroupsData)) {
          setCGroups(
            cGroupsData.map((cgroup) => ({
              label: `${cgroup?.title}${
                cgroup?.discount ? ` - ${cgroup?.discount}%` : ''
              }`,
              value: cgroup.id,
            }))
          );
        }
      }
    })();

    return () => {
      isMount.current = false;
    };
  }, []);

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        data.contact_info = JSON.stringify(data.contact_info);
        // console.log('values', data);

        if (currentData) {
          customersApi
            .update(currentData.id, data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        } else {
          customersApi
            .create(data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const handleCancel = () => {
    //form.resetFields();
    onClose();
  };

  const tabItems = [
    {
      key: '1',
      label: <IntlMessages id="global.customers" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id="global.lastname" />}
            name="lastname"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            label={<IntlMessages id="global.firstname" />}
            name="firstname"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.email" />}
            name="email"
            rules={[
              {
                type: 'email',
                message: <IntlMessages id="global.email_not_valid" />,
              },
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.phone" />}
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input.Group>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="phone_code"
                    rules={[
                      {
                        required: true,
                        message: <IntlMessages id="global.requiredfield" />,
                      },
                    ]}>
                    <Select
                      style={{ width: '100%' }}
                      allowClear
                      showSearch
                      placeholder="Select type"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }>
                      {CountryData.map((item, index) => {
                        let labelstr = '';
                        labelstr = `(+${item.code}) ${item.country}`;
                        return (
                          <Option key={index} value={`+${item.code}`}>
                            {labelstr}
                          </Option>
                        );
                      })}
                      ;
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    name="mobile"
                    rules={[
                      {
                        required: true,
                        message: <IntlMessages id="global.requiredfield" />,
                      },
                    ]}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Input.Group>
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.passport" />}
            name="passport"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.password" />}
            name="password">
            <Input.Password placeholder={place_pass} />
          </Form.Item>
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <IntlMessages id="global.edit" />
        ) : (
          <IntlMessages id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}>
          {<IntlMessages id="global.save" />}
        </Button>,
      ]}>
      <Form
        {...layout}
        form={form}
        initialValues={initialValues}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}>
        <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
      </Form>
    </Modal>
  );
}
